import React from 'react';

// Standardized display for ALL elected officials
const OfficialDisplay = ({ official, type }) => {
    if (!official) return null;
    
    const { 
        name, 
        party,
        age,
        currentAge,
        gender,
        termEnd,
        birthDate,
        district,
        tenureFormatted
    } = official;
    
    // Get the actual age (some have currentAge, some have age)
    const displayAge = currentAge || age;
    
    // Party full names
    const getPartyName = (partyCode) => {
        switch(partyCode) {
            case 'D': return 'Democrat';
            case 'R': return 'Republican';
            case 'I': return 'Independent';
            default: return partyCode;
        }
    };
    
    // Gender full names
    const getGenderName = (genderCode) => {
        switch(genderCode) {
            case 'M': return 'Male';
            case 'F': return 'Female';
            default: return genderCode;
        }
    };
    
    return (
        <div style={{
            padding: '15px',
            marginBottom: '10px',
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            borderRadius: '6px'
        }}>
            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '8px'
            }}>
                {/* Name with District if applicable */}
                <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1a1a1a' }}>
                    {name}
                    {district && (
                        <span style={{ fontWeight: 'normal', marginLeft: '10px', color: '#666' }}>
                            - District {district}
                        </span>
                    )}
                </div>
                
                {/* All details in consistent format */}
                <div style={{ 
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '10px',
                    marginTop: '8px',
                    fontSize: '14px',
                    color: '#333'
                }}>
                    <div>
                        <span style={{ fontWeight: '600', color: '#666' }}>Party: </span>
                        <span>{getPartyName(party)}</span>
                    </div>
                    
                    <div>
                        <span style={{ fontWeight: '600', color: '#666' }}>Age: </span>
                        <span>{displayAge} years</span>
                    </div>
                    
                    <div>
                        <span style={{ fontWeight: '600', color: '#666' }}>Gender: </span>
                        <span>{getGenderName(gender)}</span>
                    </div>
                    
                    <div>
                        <span style={{ fontWeight: '600', color: '#666' }}>Term Ends: </span>
                        <span>{termEnd || 'Not specified'}</span>
                    </div>
                    
                    {tenureFormatted && (
                        <div>
                            <span style={{ fontWeight: '600', color: '#666' }}>Time in Office: </span>
                            <span>{tenureFormatted}</span>
                        </div>
                    )}
                    
                    {birthDate && (
                        <div>
                            <span style={{ fontWeight: '600', color: '#666' }}>Birth Date: </span>
                            <span>{new Date(birthDate).toLocaleDateString('en-US', { 
                                year: 'numeric', 
                                month: 'long', 
                                day: 'numeric' 
                            })}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

// List component for multiple officials
export const OfficialsListDisplay = ({ officials, title, type }) => {
    if (!officials || officials.length === 0) return null;
    
    return (
        <div style={{ marginBottom: '20px' }}>
            {title && (
                <h3 style={{ 
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#1a1a1a',
                    marginBottom: '15px',
                    paddingBottom: '10px',
                    borderBottom: '2px solid #e0e0e0'
                }}>
                    {title}
                </h3>
            )}
            {officials.map((official, index) => (
                <OfficialDisplay key={index} official={official} type={type} />
            ))}
        </div>
    );
};

export default OfficialDisplay;